import {Button} from '@mira/ui';
import {Box, Center, Heading, Text, VStack} from 'platform/foundation-tw';

import {useTranslation} from 'react-i18next';

import {useNavigate} from 'shared/web';

export function NotFound() {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box minHeight="100dvh" padding={8}>
      <Center height="100%">
        <VStack spacing={6} align="center">
          <Heading size={1}>{t('notFound.heading')}</Heading>
          <Text size="large" color="secondary">
            {t('notFound.message')}
          </Text>
          <Button onClick={handleGoHome}>{t('notFound.cta')}</Button>
        </VStack>
      </Center>
    </Box>
  );
}
